"use client";

import { getFunnelStepConfig } from "../constants/funnel-data";
import { useFinancialServiceFunnelStore } from "@/app/stores/financial-service-funnel-store";

export default function FunnelHeading() {
  const { currentStep } = useFinancialServiceFunnelStore();
  const { heading } = getFunnelStepConfig(currentStep);

  return <h2 className="heading-large">{heading}</h2>;
}
